<div class="grid grid-cols-12 gap-8">
<project-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  <user-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  @if (selectedProject) {
    <project-word-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  }
  @if (!selectedProject) {
    <placeholder icolor="grey" class="col-span-12 lg:col-span-6 xl:col-span-3" />
  }
  <user-word-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  @if (selectedProject) {
    <div class="col-span-12 w-full">
      @if (selectedProject.id) {
        <div class="xl:col-span-6 col-span-12">
          <editor-space [user]="platformUser" [project]="selectedProject" />
        </div>
      }
      <div class="xl:col-span-6 col-span-12">
        <writer-resource-matches [project]="selectedProject" />
      </div>
      <div class="xl:col-span-6 col-span-12">
        <project-profile [project]="selectedProject" />
      </div>
    </div>
  }
</div>


